"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.text = exports.icon = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("./vars"),
    thunderBird = _vars.COLOURS.red.thunderBird,
    icon = (0, _cxs["default"])({
  " svg g": {
    fill: thunderBird
  }
});

exports.icon = icon;
var text = (0, _cxs["default"])({
  color: thunderBird
});
exports.text = text;